import { cloudFunctions } from './../config/Fire';
import { RESERVE_STATE } from './../constants/reserve';

export const SET_NEW_STATE_TO_RESERVE = 'SET_NEW_STATE_TO_RESERVE';
export const SET_ERROR_RESERVE = 'SET_ERROR_RESERVE';

const setReserveId = payload => ({ type: SET_NEW_STATE_TO_RESERVE, payload });
export const setErrorReserve = payload => ({ type: SET_ERROR_RESERVE, payload });

export const setNewStateToReserve = (state, newState, reserve) => {
    return dispatch => {
        //console.log(state + newState + reserve.reservationId);
        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: true }));
        switch (state) {
            case RESERVE_STATE.accepted:
                if(newState === RESERVE_STATE.assisted) {
                    return cloudFunctions.tryAssistReservation({ 
                        userId: reserve.userId,
                        reservationId: reserve.reservationId,
                        newState: newState,
                        restaurantName: reserve.restoName,
                        restoId: reserve.restoId,
                        date: reserve.date,
                        hour: reserve.hour,
                        reservePlatform: reserve.platform,
                    })
                    .then((response) => {
                        if(response.data.reserveState && response.data.reserveState === "assisted") {
                            dispatch(setErrorReserve({ state: false}));
                            dispatch(setReserveId({ id: reserve.reservationId, newState: newState, isLoading: false }));
                        }
                    })
                    .catch(err => {
                        //console.log("getRestaurant not found: " + null);
                        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                        dispatch(setErrorReserve({ state: true, rason: "ERROR"}));
                    });
                } else if(newState === RESERVE_STATE.no_assisted) {
                    return cloudFunctions.tryAssistReservation({ 
                        userId: reserve.userId,
                        reservationId: reserve.reservationId,
                        newState: newState,
                        restaurantName: reserve.restoName,
                        restoId: reserve.restoId,
                        date: reserve.date,
                        hour: reserve.hour,
                        reservePlatform: reserve.platform,
                    })
                    .then((response) => {
                        if(response.data.reserveState && response.data.reserveState === "notAssisted") {
                            dispatch(setErrorReserve({ state: false}));
                            dispatch(setReserveId({ id: reserve.reservationId, newState: newState, isLoading: false }));
                        }
                    })
                    .catch(err => {
                        //console.log("getRestaurant not found: " + null);
                        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                        dispatch(setErrorReserve({ state: true, rason: "ERROR"}));
                    });
                } else if(newState === RESERVE_STATE.rejected) {
                    return cloudFunctions.tryRejectReservation({ 
                        userId: reserve.userId,
                        reservationId: reserve.reservationId,
                        newState: newState,
                        state: state,
                        restoId: reserve.restoId,
                    })
                    .then((response) => {
                        if(response.data.reserveState && response.data.reserveState === "rejected") {
                            dispatch(setErrorReserve({ state: false}));
                            dispatch(setReserveId({ id: reserve.reservationId, newState: newState, isLoading: false }));
                        }
                    })
                    .catch(err => {
                        //console.log("getRestaurant not found: " + null);
                        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                        dispatch(setErrorReserve({ state: true, rason: "ERROR"}));
                    });
                } else {
                    dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                    return;
                }
            case RESERVE_STATE.pending:
                if(newState === RESERVE_STATE.accepted) {
                    return cloudFunctions.tryAcceptReservation({
                        restoId: reserve.restoId,
                        date: reserve.date,
                        hour: reserve.hour,
                        reserveId: reserve.reservationId,
                        peopleCount: reserve.peopleCount,
                        userId: reserve.userId,
                        reservePlatform: reserve.platform,
                    }).then((data) => {
                        if(data.data.reserveState && data.data.reserveState === "accepted") {
                            dispatch(setErrorReserve({ state: false }));
                            dispatch(setReserveId({ id: reserve.reservationId, newState: newState, isLoading: false }));
                            // actualizar datos del resto para ver los lugares ocupados
                        } else {
                            if(data.reserveState && data.reserveState === "Not available") {
                                dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                                dispatch(setErrorReserve({ state: true, reason: 'Not available' }));
                            } else {
                                dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                                dispatch(setErrorReserve({ state: true, reason: 'Not found' }));
                            }
                        }
                    }).catch((err) => {
                        //console.log("getRestaurant not found: " + null);
                        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                        dispatch(setErrorReserve({ state: true, rason: "ERROR"}));
                    });
                } else if(newState === RESERVE_STATE.rejected) {
                    return cloudFunctions.tryRejectReservation({ 
                        userId: reserve.userId,
                        reservationId: reserve.reservationId,
                        newState: newState,
                        state: state,
                        restoId: reserve.restoId,
                    })
                    .then((response) => {
                        if(response.data.reserveState && response.data.reserveState === "rejected") {
                            dispatch(setErrorReserve({ state: false}));
                            dispatch(setReserveId({ id: reserve.reservationId, newState: newState, isLoading: false }));
                        }
                    })
                    .catch(err => {
                        //console.log("getRestaurant not found: " + null);
                        dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                        dispatch(setErrorReserve({ state: true, rason: "ERROR"}));
                    });
                } else {
                    dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                    return;
                }
            default:
                dispatch(setReserveId({ id: reserve.reservationId, newState: state, isLoading: false }));
                return;
        }
    };
};